<template>
  <div class="h-app-layout" :class="isFullScreen ? 'app-main--flex' : ''">
    <div v-if="$route.name !== 'app-jump' && $route.name !== 'author-hdsec' && $route.name !== 'author-health'">
      <section class="hal-header">
        <m-header/>
      </section>
      <section :class="mainClasses" >
        <div class="hal-sidebar" :style="`width:${hasToggleSidebar ? '0px' : `${hasSidebar ? '106px' : '255px'}`}`">
          <a href="javascript:" class="hal-sidebar--toggle__open" v-if="!isErp" @click="hasToggleSidebar = !hasToggleSidebar">
            <i :class="`el-icon-s-${hasToggleSidebar ? 'unfold' : 'fold'}`"></i>
          </a>
          <m-sidebar/>
        </div>
        <div class="hal-app-main" :style="stylees">
          <div class="hal-app-breadcrumb">
            <m-breadcrumb/>
            <div class="hal-app-breadcrumb--fs" v-if="!isErp" @click="isFullScreen = true">
              <i class="el-icon-rank"></i>
            </div>
          </div>
          <div class="hal-tag-view">
            <m-tag-view/>
          </div>
          <div class="scrollbar hal-app-wrapper" :class="globalAnimation">
            <div class="hal-app-wrapper--fs" v-if="isFullScreen" @click="isFullScreen = false">
              <i class="el-icon-full-screen"></i>
            </div>
            <m-app-main v-loading="appLoading"/>
          </div>
          <div class="hal-app-copyright">
            <m-copyright/>
          </div>
        </div>
        <div class="hal-help" v-if="isHelp" :style="`width:${hasHelp ? '220px' : '0px'}`">
          <a href="javascript:" :class="`hal-help--toggle__${hasHelp ? 'close' : 'open'}`" @click="hasHelp = !hasHelp"></a>
          <m-help v-if="hasHelp"/>
        </div>
      </section>
    </div>
    <div v-else>
      <router-view />
    </div>
  </div>
</template>
<script>
  import { mapState, mapMutations } from 'vuex'
  import mHeader from './_source/header'
  import mSidebar from './_source/sidebar'
  import mAppMain from './_source/appMain'
  import '@/module/MC'
  import mTagView from './_source/tagView'
  import mBreadcrumb from './_source/breadcrumb'
  import mCopyright from './_source/copyright'
  import mHelp from './_source/help'
  import { noSubRouteArr } from './_source/ignore'
  import { handlerReUrls } from './_source/utils'

  let reUrls = []

  export default {
    name: 'h-app-layout',
    data () {
      return {
        hasSidebar: false,
        hasToggleSidebar: false,
        hasHelp: false,
        isHelp: false,
        isFullScreen: false
      }
    },
    props: {},
    methods: {
      ...mapMutations('common', ['setHelpParams'])
    },
    watch: {
      '$route': {
        deep: true,
        immediate: true,
        handler ({ path }) {
          this.hasSidebar = noSubRouteArr.includes(path)

          if (_.isEmpty(reUrls)) {
            reUrls = handlerReUrls(this.accInfo.resList)
          }
          if (!_.isEmpty(reUrls[path])) {
            this.setHelpParams({
              reId: reUrls[path],
              reUrl: path
            })
          }

          this.isHelp = !_.isEmpty(reUrls[path])
          this.hasHelp = false
        }
      },
      hasHelp (v) {
        /**
         * PM 让这么先干的，不然回退代码
         *
         */
        if (v) {
          $('.c-store-switch').css({ right: '260px' })
          $('.c-refresh-switch').css({ right: '246px' })
          $('.c-nav-tab2 .el-tabs__header').css({ width: 'calc(100% - 645px)' })
        } else {
          $('.c-store-switch').css({ right: '60px' })
          $('.c-refresh-switch').css({ right: '26px' })
          $('.c-nav-tab2 .el-tabs__header').css({ width: 'calc(100% - 425px)' })
        }
      }
    },
    beforeCreate () {
    },
    created () {
    },
    beforeMount () {
    },
    mounted () {
    },
    beforeUpdate () {
    },
    updated () {
    },
    beforeDestroy () {
    },
    destroyed () {
    },
    computed: {
      ...mapState('common', ['appLoading', 'globalAnimation', 'accInfo', 'isErp']),
      mainClasses () {
        return [
          `hal-main`,
          {
            'hal-main-small-sidebar': this.hasSidebar,
            'hal-main-small-erp': !!this.isErp
          }
        ]
      },
      stylees () {
        const { hasHelp, hasSidebar, hasToggleSidebar } = this
        const helpWidth = hasHelp ? 0 : 220
        return {
          width: `calc(100% - ${
            hasToggleSidebar
              ? hasHelp ? 220 : 0
              : hasSidebar
                ? `${326 - helpWidth}`
                : `${475 - helpWidth}`
          }px)`
        }
      }
    },
    components: { mHeader, mSidebar, mAppMain, mTagView, mBreadcrumb, mCopyright, mHelp }
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  .h-app-layout {
    .hal-header {
      height: 62px;
      background: #4a5060;
    }
    .hal-main {
      overflow: hidden;
      .hal-app-breadcrumb {
        padding-left: 20px;
        position: relative;
        &--fs {
          position: absolute;
          right: 10px;
          top: 13px;
          cursor: pointer;
          &:hover {
            i {
              color: #2d8cf0;
            }
          }
          i {
            font-size: 22px;
            color: #333;
            transform: rotateZ(
                45deg
            )
          }
        }
      }
      .hal-sidebar,.hal-app-main,.hal-help {
        float: left;
        height: calc(100vh - 62px);
      }
      .hal-sidebar {
        background: #383d4a;
        width: 106px;
        position: relative;
        z-index: 1;
        &--toggle {
          &__open {
            position: absolute;
            right: -30px;
            top: 14px;
            >i {
              color: #333;
              font-size: 20px;
            }
          }
        }
      }
      .hal-app-main {
        width: calc(100% - 475px);
        background: #F5F7FA;
        .hal-app-wrapper {
          overflow-y: scroll;
          height: calc(100vh - 170px);
        }
        .hal-app-copyright {

        }
        .scrollbar::-webkit-scrollbar {
          background: transparent;
        }
      }
      .hal-help {
        width: 220px;
        position: relative;
        z-index: 99;
        box-shadow: -1px 0px 1px 0px rgba(0, 0, 0, 0.1);
        &--toggle {
          &__open,&__close {
            position: absolute;
            left: -15px;
            top: 42%;
            width: 17px;
            height: 72px;
            display: inline-block;
          }
          &__open {
            background: url("./img/help_open.png") no-repeat;
          }
          &__close {
            left: -1px;
            background: url("./img/help_close.png") no-repeat;
          }
        }
      }
      &.hal-main-small-erp {
        transform: translateX(-106px);
        width: calc(100% - -106px);
      }
    }

    .hal-main-small-sidebar {
      .hal-sidebar {
        width: 106px;
      }
    }
    &.app-main--flex {
      .hal-app-wrapper {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 100;
        background: #fff;
        width: 100%;
        height: calc(100vh) !important;
        &--fs {
          position: fixed;
          right: 8px;
          top: 8px;
          z-index: 99;
          opacity: 0;
          cursor: pointer;
          display: block;
          transition: all 0.2s ease-out;
          i {
            font-size: 34px;
          }
        }
        &:hover {
          .hal-app-wrapper--fs {
            opacity: 0.6;
          }
        }

      }
      &.hal-main-small-erp {
        transform: translateX(-106px);
        width: calc(100% - -106px);
      }
    }



  }
</style>



// WEBPACK FOOTER //
// src/js/module/layout/index.vue